import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/messageForm/index.js